import React from 'react';

const Hero = () => (
  <section className="hero no-background">
    <div className="hero-banner">
      <video
        src="/herobanner4.mp4"
        autoPlay
        muted
        playsInline
        style={{ width: '100%' }}
      >
        Your browser does not support the video tag.
      </video>
    </div>
    <div className="hero-content">
      <h1>Welcome to ClevSheetsAI</h1>
      <p>Get your extension now by clicking Chrome Web Store icon below.</p>
      <a
        href="https://chromewebstore.google.com/detail/clevsheets/nddnbififmokefapokgbldfgaaapjdan"
        target="_blank"
        rel="noopener noreferrer"
        className="chrome-button"
      >
        <img src="/chrome-google-sheets-ai.png" loading="lazy" alt="Google Sheets AI Chrome Extension - Install ClevSheets AI" className="chrome-img" />
      </a>
    </div>
  </section>
);

export default Hero;
